<queblo-project *ngFor="let project of projects" [project]="project"></queblo-project>
